module.exports = __webpack_public_path__ + "static/media/la_factory.79631e04.svg";